import { DEFAULT_ROLES, SYSTEM_COMPONENTS_IDS } from '../app/root/constants'

const state = {
    p: {},
    user: {},
    isSet: false
}

export const UserPermissions = {
    init(user, p) {
        if (this.isSet) {
            return
        }

        state.user = user
        state.p = p
        state.isSet = true
    },
    flush() {
        state.user = {}
        state.p = {}
        state.isSet = false
    },
    get isSet() {
        return state.isSet
    },
    isDemoBillingAccess() {
        if (!this.isSet) return false
        return state.user.original_customer_id === 713
    },
    isTraplinkedAdmin() {
        if (!this.isSet) return false
        return state.user.original_role === DEFAULT_ROLES.traplinked_admin
    },
    isAdmin() {
        if (!this.isSet) return false

        return [
            DEFAULT_ROLES.customer_admin,
            DEFAULT_ROLES.traplinked_admin
        ].includes(state.user.original_role)
    },
    isSuperAdmin() {
        if (!this.isSet) return false
        return state.user.is_super_admin === true
    },
    isAllOriginalGranted() {
        if (!this.isSet) return false

        return (
            state.user.original_role === DEFAULT_ROLES.traplinked_admin ||
            state.user.original_role === DEFAULT_ROLES.customer_admin ||
            state.user.original_role === DEFAULT_ROLES.management_user
        )
    },
    isUserMgmtGranted() {
        if (!this.isSet) return false

        return (
            state.user.original_role === DEFAULT_ROLES.traplinked_admin ||
            state.user.original_role === DEFAULT_ROLES.customer_admin ||
            state.user.original_role === DEFAULT_ROLES.management_user
        )
    },
    isQCUser() {
        if (!this.isSet) return false
        return state.user.hasOwnProperty('qc') && state.user.qc === 1
    },
    isOriginalEntity(customerId) {
        if (!this.isSet) return false

        return state.user.original_customer_id === customerId
    },
    isGranted(systemComponentId, permissionCode, cId) {
        if (!this.isSet) {
            return {
                update: false,
                read: false,
                delete: false,
                create: false
            }
        }

        return checkIsGranted(systemComponentId, permissionCode, cId)
    },
    location(customerId) {
        return {
            update: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'u',
                customerId
            ),
            read: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'r',
                customerId
            ),
            delete: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'd',
                customerId
            ),
            create: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'c',
                customerId
            )
        }
    },
    locationV2(isAssigned, customerId) {
        return {
            create: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'c',
                customerId
            ),
            read: this.isGranted(
                SYSTEM_COMPONENTS_IDS.locations,
                'r',
                customerId
            ),
            update:
                (isAssigned &&
                    this.isGranted(
                        SYSTEM_COMPONENTS_IDS.locations,
                        'u',
                        customerId
                    )) ||
                (this.isAllOriginalGranted() &&
                    this.isOriginalEntity(customerId)),
            delete:
                this.isOriginalEntity(customerId) &&
                (this.isAllOriginalGranted() ||
                    (isAssigned &&
                        this.isGranted(
                            SYSTEM_COMPONENTS_IDS.locations,
                            'd',
                            customerId
                        )))
        }
    },
    device(customerId) {
        return {
            update: this.isGranted(
                SYSTEM_COMPONENTS_IDS.devices,
                'u',
                customerId
            ),
            read: this.isGranted(
                SYSTEM_COMPONENTS_IDS.devices,
                'r',
                customerId
            ),
            delete: this.isGranted(
                SYSTEM_COMPONENTS_IDS.devices,
                'd',
                customerId
            ),
            create: this.isGranted(
                SYSTEM_COMPONENTS_IDS.devices,
                'c',
                customerId
            )
        }
    },
    // includes extended roles, v1 should be considered legacy
    // TODO: use v2 everywhere where v1 used and remove v1
    deviceV2(isAssigned, customerId) {
        return {
            update:
                (isAssigned &&
                    this.isGranted(
                        SYSTEM_COMPONENTS_IDS.devices,
                        'u',
                        customerId
                    )) ||
                (this.isAllOriginalGranted() &&
                    this.isOriginalEntity(customerId)),
            delete:
                this.isOriginalEntity(customerId) &&
                (this.isAllOriginalGranted() ||
                    (isAssigned &&
                        this.isGranted(
                            SYSTEM_COMPONENTS_IDS.devices,
                            'd',
                            customerId
                        )))
            // TODO add rest of permission set
        }
    },
    report(customerId) {
        return {
            update: this.isGranted(
                SYSTEM_COMPONENTS_IDS.reports,
                'u',
                customerId
            ),
            read: this.isGranted(
                SYSTEM_COMPONENTS_IDS.reports,
                'r',
                customerId
            ),
            delete: this.isGranted(
                SYSTEM_COMPONENTS_IDS.reports,
                'd',
                customerId
            ),
            create: this.isGranted(
                SYSTEM_COMPONENTS_IDS.reports,
                'c',
                customerId
            )
        }
    },
    user() {
        return {
            update: this.isUserMgmtGranted(),
            read: this.isUserMgmtGranted(),
            delete: this.isAdmin(),
            create: this.isUserMgmtGranted()
        }
        // return {
        //     update: this.isGranted(
        //         SYSTEM_COMPONENTS_IDS.user_management,
        //         'u',
        //         customerId
        //     ),
        //     read: this.isGranted(
        //         SYSTEM_COMPONENTS_IDS.user_management,
        //         'r',
        //         customerId
        //     ),
        //     delete: this.isGranted(
        //         SYSTEM_COMPONENTS_IDS.user_management,
        //         'd',
        //         customerId
        //     ),
        //     create: this.isGranted(
        //         SYSTEM_COMPONENTS_IDS.user_management,
        //         'c',
        //         customerId
        //     )
        // }
    },
    customer(customerId) {
        return {
            update: this.isGranted(
                SYSTEM_COMPONENTS_IDS.customers,
                'u',
                customerId
            ),
            read: this.isGranted(
                SYSTEM_COMPONENTS_IDS.customers,
                'r',
                customerId
            ),
            delete: this.isGranted(
                SYSTEM_COMPONENTS_IDS.customers,
                'd',
                customerId
            ),
            create: this.isGranted(
                SYSTEM_COMPONENTS_IDS.customers,
                'c',
                customerId
            )
        }
    },
    customComponentId(componentId, customerId) {
        return {
            update: this.isGranted(componentId, 'u', customerId),
            read: this.isGranted(componentId, 'r', customerId),
            delete: this.isGranted(componentId, 'd', customerId),
            create: this.isGranted(componentId, 'c', customerId)
        }
    }
}

function checkIsGranted(systemComponentId, permissionCode, cId) {
    const { user, p } = state

    if (
        user.original_role === DEFAULT_ROLES.traplinked_admin &&
        systemComponentId !== SYSTEM_COMPONENTS_IDS.user_management
    ) {
        return true
    }

    if (!cId) {
        return Object.keys(p).some(customerId => {
            return (
                p.hasOwnProperty(customerId) &&
                p[customerId].hasOwnProperty(systemComponentId) &&
                p[customerId][systemComponentId].indexOf(permissionCode) >= 0
            )
        })
    }

    if (Array.isArray(cId)) {
        return cId.some(customerId => {
            return (
                p.hasOwnProperty(customerId) &&
                p[customerId].hasOwnProperty(systemComponentId) &&
                p[customerId][systemComponentId].indexOf(permissionCode) >= 0
            )
        })
    }

    return (
        p.hasOwnProperty(cId) &&
        p[cId].hasOwnProperty(systemComponentId) &&
        p[cId][systemComponentId].indexOf(permissionCode) >= 0
    )
}
